export default __webpack_public_path__ + "static/media/challenge.f09b8743.mp3";